import { TogglerCheckbox } from '@factorialco/deprecated-design-system'
import { Field } from 'factorial-form'
import { DataSchemaItemFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

interface Props {
  dataSchemaItem: DataSchemaItemFragment
  field: Field
}

export const BooleanField = observer(({ dataSchemaItem, field }: Props) => {
  const value = field.value == '' ? false : field.value
  return (
    <TogglerCheckbox
      label={dataSchemaItem.label}
      value={value}
      onChange={(newValue) => field.set(newValue)}
    />
  )
})
